import type { QueryClientConfig } from "@tanstack/react-query";

// TUT-208 / Plataforma Sprint 1 (Task 1): sem `staleTime`, o padrão do
// react-query (0) marca toda query como velha no instante em que resolve, e o
// `refetchOnMount` padrão (true) refaz TODAS as requisições a cada troca de
// tela — a navegação parecia lenta porque cada montagem esperava o servidor de
// novo. As TUTs 200+ (nove domínios comerciais) tornaram a enxurrada visível.
// Com 30s de frescor, voltar a uma tela recém-visitada responde do cache;
// telas com necessidade própria (o widget de tempo real do Dashboard, por
// exemplo) declaram o SEU `staleTime`/refetch local, que vence este default. A
// invalidação após mutação continua refazendo na hora.
//
// Esta config vive em módulo próprio — e não inline no `main.tsx` — para que a
// guarda de regressão (`query-client-defaults.test.ts`) a leia sem montar o
// app: `main.tsx` chama `createRoot` no topo, e importá-lo num teste dispararia
// o mount contra um DOM sem `#root`.
export const queryClientOptions = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
      gcTime: 5 * 60 * 1000,
    },
  },
} satisfies QueryClientConfig;
